export const BANK_API_REQUEST="BANK/API_REQUEST";
export const BANK_API_SUCCESS="BANK/API_SUCCESS";
export const BANK_API_FAILED="BANK/API_FAILED";
